<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Reports</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="search">
      <div class="row align-items-center">
        <div class="col-md-2">Company</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="company">
            <option value="">-- Please Select --</option>
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-4">Year</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="year">
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Type of Insurance</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="typeId">
            <option value="">-- Please Select --</option>
            <option v-for="item in types" :key="item.Id" :value="item.Id">
              {{ item.Description }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-4">Group Dental</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="groupDental">
            <option value="">-- Please Select --</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-md-2">Enrolment Category</div>
        <div class="col-md-4 pl-md-0">
          <select class="custom-select" v-model="categoryId">
            <option value="">-- Please Select --</option>
            <option v-for="item in categories" :key="item.Id" :value="item.Id">
              {{ item.Description }}
            </option>
          </select>
        </div>
        <div class="col-md-2 ml-md-4">Group H&S and MM</div>
        <div class="col-md-3 pl-md-0">
          <select class="custom-select" v-model="groupHsmm">
            <option value="">-- Please Select --</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
        <div class="col-md-1">
          <button type="submit" class="btn btn-primary">Search</button>
        </div>
      </div>
    </form>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4 align-items-center" v-if="records && records.length">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-right">
        <form
          :action="backendUrl + '/InsuranceExcelReport/ExportExcel'"
          method="POST"
        >
          <input type="hidden" name="Company" :value="companyForExcel" />
          <input type="hidden" name="InsuranceYear" :value="yearForExcel" />
          <input type="hidden" name="InsuranceType" :value="typeIdForExcel" />
          <input
            type="hidden"
            name="GroupDental"
            :value="groupDentalForExcel"
          />
          <input
            type="hidden"
            name="EnrolmentCategory"
            :value="categoryIdForExcel"
          />
          <input type="hidden" name="GroupHsmm" :value="groupHsmmForExcel" />
          <button type="submit" class="btn btn-sm btn-primary">
            <img
              width="20px"
              height="20px"
              class="mr-1"
              src="../../assets/excel.png"
            />Export to Excel
          </button>
        </form>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result Empty -->
    <div class="mt-4" v-if="records && records.length == 0">
      <div class="col-12 no-record">
        {{ noRecordText }}
      </div>
    </div>

    <!-- Result -->
    <div class="row mt-2" v-if="records && records.length">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th>Employee ID</th>
                <th>Employee Name</th>
                <th>Date Join</th>
                <th>Date Left</th>
                <th>Insurance Year</th>
                <th>Type of Insurance</th>
                <th>Enrolment Category</th>
                <th>No. of Children</th>
                <th>Currency</th>
                <th>Amount</th>
                <th>Dependent Year</th>
                <th>Dependent Name</th>
                <th>Group Dental</th>
                <th>Group H&S and MM</th>
                <th>Dependent Relationship</th>
                <th>Dependent Marital Status</th>
                <th>Dependent IC Number</th>
                <th>Dependent Nationality</th>
                <th>Dependent Gender</th>
                <th>Dependent Birthday</th>
                <th>Dependent Age</th>
                <th>Is your child on full-time studies?</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in records" :key="i">
                <td>{{ item.EmployeeID }}</td>
                <td>{{ item.EmployeeName }}</td>
                <td>{{ item.DateJoinDisplay }}</td>
                <td>{{ item.DateLeftDisplay }}</td>
                <td>{{ item.InsuranceYear }}</td>
                <td>{{ item.InsuranceType }}</td>
                <td>{{ item.EnrolmentCategory }}</td>
                <td>{{ item.NoOfChildren }}</td>
                <td>{{ item.Currency }}</td>
                <td>{{ item.Amount }}</td>
                <td>{{ item.DependentYear }}</td>
                <td>{{ item.DependentName }}</td>
                <td>{{ item.GroupDental }}</td>
                <td>{{ item.GroupHsmm }}</td>
                <td>{{ item.DependentRelationship }}</td>
                <td>{{ item.DependentMaritalStatus }}</td>
                <td>{{ item.DependentIcNumber }}</td>
                <td>{{ item.DependentNationality }}</td>
                <td>{{ item.DependentGender }}</td>
                <td>{{ item.DependentBirthdayDisplay }}</td>
                <td>{{ item.DependentAge }}</td>
                <td>{{ item.ChildOnFullTimeStudy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Result -->

    <!-- Pagination -->
    <div class="row" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!-- /Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      companies: [],
      years: [],
      types: [],
      categories: [],
      records: [],
      //search form
      company: "",
      year: "",
      typeId: "",
      categoryId: "",
      groupDental: "",
      groupHsmm: "",
      //for excel
      companyForExcel: "",
      yearForExcel: "",
      typeIdForExcel: "",
      categoryIdForExcel: "",
      groupDentalForExcel: "",
      groupHsmmForExcel: "",
      noRecordText: config.NO_RECORD_TEXT,
      //pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 5,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    backendUrl() {
      return this.$backendUrl;
    },
  },

  watch: {
    typeId(val) {
      this.categoryId = "";
      if (!val) {
        this.categories = [];
        return;
      }
      let param = {
        Token: this.token,
        Id: val,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingEnrolmentCategories(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.categories = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.search();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getYears(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.years = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getInsuranceTypes() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceCategoryMappingInsuranceTypes(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.types = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    search() {
      //store variable for export excel
      this.companyForExcel = this.company;
      this.yearForExcel = this.year;
      this.typeIdForExcel = this.typeId;
      this.categoryIdForExcel = this.categoryId;
      this.groupDentalForExcel = this.groupDental;
      this.groupHsmmForExcel = this.groupHsmm;
      //actual search
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
        Company: this.company,
        InsuranceYear: this.year,
        InsuranceType: this.typeId,
        GroupDental: this.groupDental,
        EnrolmentCategory: this.categoryId,
        GroupHsmm: this.groupHsmm,
      };
      this.$store.state.isLoading = true;
      API.getInsuranceReport(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.search();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.search();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.search();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.search();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.search();
    },
  },

  created() {
    if (this.role != "admin") {
      this.$router.replace({ name: "home" });
      return;
    }
    this.getCompanies();
    this.getYears();
    this.getInsuranceTypes();
  },
};
</script>

<style scoped>
.col-md-2 {
  max-width: 185px;
}
</style>


// WEBPACK FOOTER //
// src/components/Insurance/Report.vue